module.exports = __webpack_public_path__ + "static/media/img_screen_POS.bc8ba5db.png";